export type ConditionSeverityStatus =
  | 'Critical Condition'
  | 'Potential problem'
  | 'Alarm Condition'
  | 'Not monitored'
  | 'Not Operated';

export const SeverityStatusColorMap: { [key in ConditionSeverityStatus]: string } = {
  'Critical Condition': '#FF5454',
  'Potential problem': '#FFA3A3',
  'Alarm Condition': '#FFB054',
  'Not monitored': '#F2F2F2',
  'Not Operated': '#828282',
};
